Vue.component('game-example', require('./games/GameExample.vue').default);
Vue.component('game-kang-summer-wheel-2025', require('./games/GameKangSummerWheel2025').default);
